export default __webpack_public_path__ + "static/media/sampleDog.60600ade.jpg";